module.exports = __webpack_public_path__ + "img/free08_800x400.1b4b73d3.jpg";